import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { i18n } from 'i18next';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { StepUpProvider } from '@/features/account/step-up';
import { HltProvider } from '@hlt/web-kit/theme';
import { ToastProvider } from '@hlt/web-kit/ui';

export function Providers({
    queryClient,
    i18n,
    children,
}: {
    queryClient: QueryClient;
    i18n: i18n;
    children: ReactNode;
}) {
    return (
        <HltProvider>
            <I18nextProvider i18n={i18n}>
                <QueryClientProvider client={queryClient}>
                    <ToastProvider>
                        <StepUpProvider>{children}</StepUpProvider>
                    </ToastProvider>
                </QueryClientProvider>
            </I18nextProvider>
        </HltProvider>
    );
}
